import { render, staticRenderFns } from "./ModalDocumentPackage.vue?vue&type=template&id=6bb90987&"
import script from "./ModalDocumentPackage.vue?vue&type=script&lang=js&"
export * from "./ModalDocumentPackage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports